// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'business',
  icon: [
    191,
    512,
    null,
    null,
    'M39.15 0l9.03 88.21h93.92L155.63 0H39.15zm18.1 109.73L.77 435.95 95.72 512l94.94-76.05-59.87-326.22H57.25z',
  ],
})
